/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment form action helpers
 *
 * @file assignmentFormActions.js
 * @author Gladson Samuel S
 * @since 2.0.0
 */

export const ASSIGNMENT_FORM_MODE = {
  CREATE: 'create',
  EDIT: 'edit'
};

export const ASSIGNMENT_SAVE_ACTION = {
  FINISH: 'FINISH',
  SAVE_AND_ADD: 'SAVE_AND_ADD'
};

export const EMPTY_ASSIGNMENT_FORM_VALUES = {
  dueDate: '',
  dueTime: '23:59',
  timeZone: 'America/New_York',
  chapters: [],
  assignmentName: ''
};

export function isActionDisabled({
  mode,
  isValid,
  isDirty = true,
  hasContent = true,
  isTitleGenerating = false
}) {
  if (!hasContent || isTitleGenerating) {
    return true;
  }

  if (!isValid) {
    return true;
  }

  if (mode === ASSIGNMENT_FORM_MODE.EDIT && !isDirty) {
    return true;
  }

  return false;
}
